/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Comments",
  size: 20
}

const SvgComments = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path fill="none" d="M2 .5h17.5V13" />
    <path d="M5 19.71V15H0V2h18v13H9.71L5 19.71zM1 14h5v3.29L9.29 14H17V3H1v11z" />
  </Svg>
)

SvgComments.defaultProps = defaultProps
export default SvgComments
